var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEuropean(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 40,
    viewBox: "0 0 60 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40,
    fill: "#E8EBED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.988 30V11.324H26.784V14.208H17.264V19.052H26.588V21.936H17.264V27.116H26.784V30H13.988ZM38.2402 30.336C36.8775 30.336 35.6922 30.1493 34.6842 29.776C33.6762 29.4027 32.8362 28.88 32.1642 28.208C31.4922 27.536 30.9882 26.7333 30.6522 25.8C30.3162 24.848 30.1482 23.7933 30.1482 22.636V11.324H33.4522V22.524C33.4522 24.0173 33.8535 25.212 34.6562 26.108C35.4588 26.9853 36.6535 27.424 38.2402 27.424C39.8082 27.424 40.9935 26.9853 41.7962 26.108C42.5988 25.212 43.0002 24.0173 43.0002 22.524V11.324H46.3042V22.608C46.3042 23.7653 46.1362 24.82 45.8002 25.772C45.4642 26.724 44.9602 27.536 44.2882 28.208C43.6162 28.88 42.7762 29.4027 41.7682 29.776C40.7602 30.1493 39.5842 30.336 38.2402 30.336Z",
    fill: "#001247"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEuropean);
export default __webpack_public_path__ + "static/media/icon-European.ec7186d1.svg";
export { ForwardRef as ReactComponent };